<template>
<svg class="cnm-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 19.8667a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.8667a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
